<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      autocomplete="on"
      label-position="left"
    >
      <div class="title-container">
        <h3 class="title">
            <img src="../../assets/logo.png" alt="">
        </h3>
      </div>
      <el-form-item class="codebox" prop="usernames">
        <!-- <span class="svg-container">
          <svg-icon icon-class="user" />
        </span> -->
        <!-- <i class="el-icon-s-custom"></i> -->
        <span class="login_left">旧密码</span>
        <el-input
          ref="usernames"
          v-model="loginForm.oldPassword"
          placeholder="请输入旧密码"
          name="usernames"
          type="text"
          tabindex="1"
          autofocus
        />
      </el-form-item>
      <el-tooltip
        v-model="capsTooltip"
        content="Caps lock is On"
        placement="right"
        manual
      >
        <el-form-item class="codebox">
          <!-- <span class="svg-container">
            <svg-icon icon-class="password" />
          </span> -->
          <!-- <i class="el-icon-s-opportunity"></i> -->
          <span class="login_left">新密码</span>
          <el-input
            ref="password"
            v-model="loginForm.password"
            type="text"
            placeholder="请输入新密码"
            name="password"
            tabindex="2"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
      </el-tooltip>
      <el-form-item class="codebox" prop="usercode">
        <span class="login_left">确认密码</span>
        <el-input
          ref="usercode"
          v-model="loginForm.newPassword"
          placeholder="请输入确认密码"
          name="usercode"
          type="text"
          tabindex="3"
          autofocus
          class="code_class"
        />
      </el-form-item>
     <div style="width:100%; display: flex; justify-content: center;">
          <el-button
        :loading="loading"
        type="primary"
        style="width: 302px; height:51px; border-radius: 25.5px;; background: rgba(238, 238, 238, 0.22); color: #009B43; border: 1px solid #009B43; margin-top: 81px"
        @click.native.prevent="handleLogin"
      >
        <!-- {{ $t('login.logIn') }} -->
        确认修改
      </el-button>
     </div>
      <div style="position: relative" />
    </el-form>
  </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
// // import LangSelect from '@/components/LangSelect'
// import { getAllApi } from '@/api/system'
// import SocialSign from './components/SocialSignin'
// import { login } from '@/api/user.js'

export default {
  name: "Login",
  //   components: { SocialSign },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    const validateCaptcha = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    return {
      url: "",
      loginForm: {
        oldPassword: "",
        password: "",
        newPassword: "",
        id: "",
      },
      loginRules: {
        oldPassword: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
        newPassword: [{ required: true, trigger: "blur", validator: validateCaptcha }],
      },
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      redirect: undefined,
      isCurrent: true,
      otherQuery: {},
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getCaptcha();
    // window.addEventListener('storage', this.afterQRScan)
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    // 获取验证码
    getCaptcha() {
      depot
        .get({
          url: "/backend/sign/getCaptcha",
          config: {},
          // cb: (res) => {
          // },
        })
        .then((res) => {
          console.log(res);
          this.loginForm.id = res.data.id;
          this.url = res.data.data;
        });
    },
    // 监听密码键盘事件
    checkCapslock({ shiftKey, key } = {}) {
      console.log(shiftKey);
      console.log(key);
      console.log(this.capsTooltip);
      if (key && key.length === 1) {
        if (
          (shiftKey && key >= "a" && key <= "z") ||
          (!shiftKey && key >= "A" && key <= "Z")
        ) {
          this.capsTooltip = true;
        } else {
          this.capsTooltip = false;
        }
      }
      if (key === "CapsLock" && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    // 点击显示密码
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    // 请求登录接口
    handleLogin() {
      if(this.loginForm.password == this.loginForm.newPassword) {
          this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          depot
            .post({
              url: "/backend/manager/updateInitPassword",
              data: this.loginForm,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.loading = false;
                this.$message({
                  message: "修改密码成功，请重新登录",
                  type: "success",
                });
                // setInterval(() => {
                  this.$router.push({ path: "/login" });
                // }, 1000);
                return;
              }
              this.$message({
                message: res.msg,
                type: "error",
              });
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
            });
          //   login(this.loginForm).then((res) => {
          //     sessionStorage.setItem('token', res.data.token)
          //     localStorage.setItem('token', res.data.token)
          //     // this.getAllApis()
          //     sessionStorage.setItem('userInfos', JSON.stringify(res.data.user))
          //     // this.$store.commit('settoken', res.data.token)
          //     this.loading = false
          //   }).catch((err) => {
          //     console.log(err)
          //     this.loading = false
          //   })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      }else {
          this.$message({
                message: '两次密码不一致，请重新输入',
                type: "error",
              });
      }
      console.log(JSON.stringify(this.loginForm));
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    // getAllApis() {
    //   // 获取所有API
    //   getAllApi({}).then(res => {
    //     const apiObj = {}
    //     res.data.forEach((v, i) => {
    //       if ([v.primary_key]) {
    //         apiObj[v.primary_key] = { path: v.path, method: v.method }
    //       }
    //     })
    //     // 存 session防止刷新丢失
    //     sessionStorage.setItem('apiList', JSON.stringify(apiObj))
    //     this.$router.push({ path: 'dashboard' })
    //     // 存  vuex
    //     this.$store.state.app.apiList = apiObj
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // }
  },
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
    background: rgb(255, 250, 250)!important;
    border-radius: 4px!important;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;
      color: #303030;
      caret-color: #303030;
      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #fff inset !important;
        -webkit-text-fill-color: #303030 !important;
      }
    }
  }

  .el-form-item {
    // border-bottom: 1px solid #aaaaaa;
    // background: rgba(0, 0, 0, 0.3);
    // border-radius: 5px;
    color: #303030;
    // background: #fff;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.text {
  .current {
    transform: translate(-150px);
    opacity: 0;
  }

  min-height: 100%;
  width: 100%;
  background: rgba(49, 51, 64, 1);
  opacity: 0.84;
  position: absolute;
  top: 0;
  left: 0;
  .text_content {
    width: 564px;
    position: absolute;
    top: 380px;
    left: 220px;
    height: 323px;
    text-align: center;
    user-select: none;
    .name {
      width: 100%;
      height: 67px;
      font-size: 48px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 67px;
    }
    .title {
      width: 100%;
      height: 33px;
      font-size: 24px;
      color: rgba(255, 255, 255, 1);
      line-height: 33px;
      letter-spacing: 12px;
    }
    .line {
      width: 160px;
      height: 1px;
      background: rgba(255, 255, 255, 1);
      margin: 25px auto;
    }
    .txt {
      width: 100%;
      font-size: 28px;
      color: rgba(255, 255, 255, 1);
      line-height: 56px;
      transition: transform 1s;
    }
  }
}
.login-container {
  position: relative;
  min-height: 100%;
  width: 100%;
  // background-color: $bg;
  background: url("../../assets/backimg.png") no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  .login-form {
    position: fixed;
    max-width: 100%;
    // padding: 35px;
    padding: 69px 128px 94px;
    // margin: 125px auto;
    left:50%;
    margin-left:-330px;
    overflow: hidden;
    width: 660px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    box-sizing: border-box;
    z-index: 999;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    // color: $dark_gray;
    color: #5997fd;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;
    margin-bottom: 90px;
    .title {
      font-size: 42px;
      color: #5997fd;
      // color:#eee;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: 500;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
/deep/.codebox .el-form-item__content {
  display: flex !important;
  align-items: center;
}
.login_left {
    display: inline-block;
    margin-right: 20px;
    width: 75px;
    text-align: right;
}
/deep/.el-form-item__content {
    display: flex;
}
.code_class {
    // width: 185px!important;
    // margin-right:15px;
}
</style>



// WEBPACK FOOTER //
// src/views/userpassword/index.vue